var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Text } from 'shared/components/ui';
/**
 * Highlighted terms are in between special characters. Example: |>frog<|
 * We need to split on these characters to find the terms to highlight
 */
export var HighlightedString = function (_a) {
    var text = _a.text, fontSize = _a.fontSize, inputString = _a.inputString;
    var alligatorText;
    if (inputString && inputString.length > 0) {
        var regEx = new RegExp('(' + inputString + ')', 'gi');
        // Surrounds the text to highlight with alligators, e.g. |>frog<|
        alligatorText = text === null || text === void 0 ? void 0 : text.replace(regEx, '|>$1<|');
    }
    return (_jsx(_Fragment, { children: !!alligatorText &&
            alligatorText.split(/(\|>[^>]*?<\|)/).map(function (elem, idx) {
                if (elem.startsWith('|>')) {
                    return (_jsx(Text, __assign({ as: "span", backgroundColor: "#F4F6A4", fontSize: fontSize }, { children: elem.substring(2, elem.length - 2) }), idx));
                }
                return elem;
            }) }));
};
